import {
  FIELD_SETTING_OBJECTS,
  FIELD_SETTING_PATH,
} from 'hb-builder/components/BuilderComponents/dynamic/Publication/PublicationSettings/constants/fieldSettingsObjects';
import { DisplayFieldOptionInFieldList } from 'hb-builder/components/common/SettingsLibrary/CommonSettings/DisplayFieldOption';
import AccordionTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/AccordionTitle';

const findFieldSetting = (field, contentType) =>
  FIELD_SETTING_OBJECTS[contentType].find(
    (fieldSetting) => fieldSetting.identifier === field,
  );

const FieldsDrawer = ({ contentType, item, onChange }) => {
  const { dynamicAttributes } = item.attributes;
  const fieldsAttributes = Object.keys(dynamicAttributes.fields);

  const renderFieldsSettings = (fieldsAttributes) =>
    fieldsAttributes.map((field, index) => {
      const fieldSetting = findFieldSetting(field, contentType);

      if (!fieldSetting) {
        return null;
      }

      return (
        <DisplayFieldOptionInFieldList
          fieldSetting={fieldSetting}
          fieldSettingPath={FIELD_SETTING_PATH}
          index={index}
          item={item}
          key={fieldSetting.identifier}
          onChange={onChange}
        />
      );
    });

  return (
    <AccordionTitle isInitiallyOpen title={__('Fields')}>
      {renderFieldsSettings(fieldsAttributes)}
    </AccordionTitle>
  );
};

export default FieldsDrawer;
